import { ComponentType, ReactNode, Suspense } from 'react'

// TODO: Move it from ui components :)
export const withSuspense = <P extends object>(
	Component: ComponentType<P>,
	FallbackComponent: ComponentType<P> | ReactNode
) => {
	// eslint-disable-next-line react/display-name
	return (props: P) => (
		<Suspense
			fallback={
				typeof FallbackComponent === 'function' ? (
					<FallbackComponent {...props} />
				) : (
					FallbackComponent
				)
			}
		>
			<Component {...props} />
		</Suspense>
	)
}
